export * from "./menu";
export * from "./routes";
export * from "./msalConfig";

export const VERSION_NUMBER = "4.0.0";

export const SETTING_WAIT_TIME_NUMBER_GROUPS = "OM_WaitTimeNumberGroups";
export const SETTING_QUEUE_ENABLE_TELEHEALTH = "Queue_EnableTelehealth";
export const SETTING_OM_TELEHEALTH_PROMPT_TIME = "OM_TelehealthPromptTime";
export const SETTING_OM_ENABLE_TELEHEALTH = "OM_EnableTelehealth";
export const SETTING_OM_ENABLE_MEMBERSHIP = "OM_EnableMembership";

export const CONSULT_TABLE_PAGE_SIZE = 20;
export const DOCTOR_TABLE_PAGE_SIZE = 20;
export const AUDITLOG_TABLE_PAGE_SIZE = 100;

export enum StatusReason {
	ASSIGNED = "Assigned",
	QUEUED = "Queued",
	WAITING = "Waiting",
	COMPLETED = "Completed",
	WITHDOCTOR = "WithDoctor"
}

export enum VisitType {
	None = "None",
	Local = "Local",
	LocalTelehealth = "LocalTelehealth",
	RemoteTelehealth = "RemoteTelehealth"
}
